var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 25,
    viewBox: "0 0 28 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0059 13.2577L14.0111 23L4.01628 13.2577C3.35703 12.6263 2.83775 11.8675 2.49114 11.0289C2.14452 10.1903 1.97809 9.29015 2.00231 8.38515C2.02653 7.48014 2.24089 6.58988 2.63188 5.77041C3.02287 4.95095 3.58202 4.22004 4.27413 3.6237C4.96624 3.02737 5.77631 2.57853 6.65333 2.30545C7.53035 2.03237 8.45532 1.94097 9.37 2.037C10.2847 2.13303 11.1692 2.41441 11.968 2.86342C12.7668 3.31243 13.4624 3.91935 14.0111 4.64596C14.5622 3.92463 15.2586 3.32301 16.0568 2.87876C16.855 2.43452 17.7378 2.1572 18.6499 2.06417C19.5621 1.97114 20.4839 2.0644 21.3577 2.33812C22.2315 2.61184 23.0385 3.06011 23.7281 3.65489C24.4178 4.24968 24.9753 4.97816 25.3658 5.79475C25.7562 6.61134 25.9712 7.49846 25.9973 8.40059C26.0234 9.30272 25.86 10.2004 25.5173 11.0375C25.1747 11.8747 24.6601 12.6332 24.0059 13.2656",
    stroke: "#D6AF66",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.132fef2afecc8cbe759c764c2e31680d.svg";
export { ForwardRef as ReactComponent };